import fetch from '@/utils/fetch';

// 查询所有的资源列表根据课程id
export function getMoralEduOLResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('courseId', args.courseId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getMoralEduOLResourcePageList',
        method: 'post',
        data: params
    });
}


// 各校访问统计
export function getResourceSchoolReadDataList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourceSchoolReadDataList',
        method: 'post',
        data: params
    });
}

// 按学校统计
export function getAllSchoolReadDataList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('searchType', args.searchType);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getAllSchoolReadDataList',
        method: 'post',
        data: params
    });
}

// 访问曲线

export function getResourceStaticsDataInfo(args) {

    return fetch({
        headers: {
            'content-type': 'application/json'
        },
        url: '/structure/moralEduOLResource/getResourceStaticsDataInfo',
        method: 'post',
        data: JSON.stringify(args)
    });
}


// 资源总览（按区）

export function getAreaResourceStaticsDataInfo(args) {
    let params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getAreaResourceStaticsDataInfo',
        method: 'post',
        data: params
    });
}

// 各校访问统计（按区）

export function getAreaResourceSchoolReadDataList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchType', args.searchType);
    params.append('moralType', 1001);
    params.append('areaCode', args.areaCode);

    return fetch({
        url: '/structure/moralEduOLResource/getAreaResourceSchoolReadDataList',
        method: 'post',
        data: params
    });
}

// 访问曲线（按区）
export function getAreaResourceReadCurveDataList(args) {
    let params = new URLSearchParams();
    params.append('areaCode', args.areaCode);
    params.append('searchType', args.searchType);
    params.append('startTime', args.startTime);
    params.append('endTime', args.endTime);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getAreaResourceReadCurveDataList',
        method: 'post',
        data: params
    });
}

// 按资源统计
export function getAreaTypeResourceStaticsDataList(args) {
    let params = new URLSearchParams();
    params.append('searchType', args.searchType);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('moralType', 1001);
    params.append('areaCode', args.areaCode);

    return fetch({
        url: '/structure/moralEduOLResource/getAreaTypeResourceStaticsDataList',
        method: 'post',
        data: params
    });
}

// 资源学校学生未观看记录
export function getResourceStudentNotReadList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('schoolId', args.schoolId);
    params.append('searchTitle', args.searchTitle);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourceStudentNotReadList',
        method: 'post',
        data: params
    });
}

// 资源学校教师未观看记录
export function getResourceTeacherNotReadList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('schoolId', args.schoolId);
    params.append('searchTitle', args.searchTitle);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourceTeacherNotReadList',
        method: 'post',
        data: params
    });
}

// 资源学校学生观看记录
export function getResourceStudentReadList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('schoolId', args.schoolId);
    params.append('searchTitle', args.searchTitle);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourceStudentReadList',
        method: 'post',
        data: params
    });
}

// 资源学校教师观看记录
export function getResourceTeacherReadList(args) {
    let params = new URLSearchParams();
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('resourceId', args.resourceId);
    params.append('schoolId', args.schoolId);
    params.append('searchTitle', args.searchTitle);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getResourceTeacherReadList',
        method: 'post',
        data: params
    });
}
// 学校年级资源观看统计
export function getSchoolGradeResourceViewDataList(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);
    params.append('termId', args.termId);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getSchoolGradeResourceViewDataList',
        method: 'post',
        data: params
    });
}

// 学校班级资源观看统计
export function getSchoolClassResourceViewDataList(args) {
    let params = new URLSearchParams();
    params.append('gradeId', args.gradeId);
    params.append('resourceId', args.resourceId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLResource/getSchoolClassResourceViewDataList',
        method: 'post',
        data: params
    });
}

// 查询学校所有第一学期列表
export function setSchoolYearAndTermList(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/schoolTime/setSchoolYearAndTermList',
        method: 'post',
        data: params
    });
}

// 获得用户管理的区域列表
export function getUserStaticAreaCodeList(args) {
    let params = new URLSearchParams();
    params.append('moralType', 1001);

    return fetch({
        url: '/structure/moralEduOLStaticianSet/getUserStaticAreaCodeList',
        method: 'post',
        data: params
    });
}

/*学生统计使用根据学校ID获得资源分页列表*/
export function getSchoolResourcePageList(args) {
    let params = new URLSearchParams();
    params.append('moralType', 1001);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);
    params.append('subjectId', args.subjectId);
    return fetch({
        url: '/structure/moralEduOLResource/getSchoolResourcePageList',
        method: 'post',
        data: params
    });
}

/*从考点直击课程中获得学校的学科列表*/
export function getSchoolCurriculumnList(args) {
    let params = new URLSearchParams();
    return fetch({
        url: '/structure/moralEduOLCourse/getSchoolCurriculumnList',
        method: 'post',
        data: params
    });
}

/*获得学校的某个资源的观看统计数据*/
export function getSchoolResourceReadDataInfo(args) {
    let params = new URLSearchParams();
    params.append('resourceId', args.resourceId);
    return fetch({
        url: '/structure/moralEduOLResource/getSchoolResourceReadDataInfo',
        method: 'post',
        data: params
    });
}

// 校端资源统计-资源列表
export function getSchoolResourceStaticsForSchool(args) {
    let params = new URLSearchParams();
    params.append('moralType', 1001);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);
    params.append('searchType', args.searchType);
    params.append('searchType', args.searchType);

    return fetch({
        url: '/structure/moralEduOLResource/getSchoolResourceStaticsForSchool',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/accounting/accounting.js